export class LoanConditionApiV2 {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCondition({ signal, ...params }) {
    return this.#http.get(`/loanCondition`, {
      params,
      signal,
      paramsSerializer: { indexes: null },
    });
  }

  async getBrokerCondition({ signal, ...params }) {
    return this.#http.get(`/api/loanConditions`, {
      params,
      signal,
      paramsSerializer: { indexes: null },
    });
  }

  async getConditionById({ loanConditionId }) {
    return this.#http.get(`/loanCondition/${loanConditionId}`);
  }

  async deleteCondition({ loanConditionId }) {
    return this.#http.delete(`/loanCondition/${loanConditionId}`);
  }

  async getLoanConditionSummary({ loanId }) {
    return this.#http.get(`/loanCondition/loan/${loanId}/summary`);
  }

  async editCondition({ loanConditionId }) {
    return this.#http.put(`/loanCondition/${loanConditionId}/signOff`);
  }

  async unsignOffCondition({ loanConditionId }) {
    return this.#http.put(`/loanCondition/${loanConditionId}/unsignOff`);
  }

  async signOffViaPipeline({ loanConditionId, ...params }) {
    return this.#http.put(`/loanCondition/${loanConditionId}/signOffViaPipeline`, null, { params });
  }

  async unsignOffViaPipeline({ loanConditionId, ...params }) {
    return this.#http.put(`/loanCondition/${loanConditionId}/unsignOffViaPipeline`, null, {
      params,
    });
  }

  async rejectCondition({ loanConditionId, reason }) {
    return this.#http.put(`/loanCondition/${loanConditionId}/reject`, { reason });
  }

  async createCondition(body) {
    return this.#http.post('/loanCondition/v2', body);
  }

  async createBrokerCondition(body) {
    return this.#http.post('/api/loanConditions', body);
  }

  async editConditionPriorToType(body) {
    return this.#http.put('/loanCondition/priorToType', body);
  }

  async editBrokerCondition({ loanConditionId, ...body }) {
    return this.#http.put(`/api/loanConditions/${loanConditionId}`, body);
  }

  async addConditionTasks({ loanConditionId, tasks }) {
    return this.#http.post(`/api/loanConditions/${loanConditionId}/tasks`, { tasks });
  }

  async linkConditionTasks({ loanConditionId, taskIds }) {
    return this.#http.post(`/api/loanConditions/${loanConditionId}/tasks/link`, { taskIds });
  }

  async unlinkConditionTask({ loanConditionId, taskId }) {
    return this.#http.delete(`/api/loanConditions/${loanConditionId}/tasks/${taskId}/link`);
  }

  async removeConditionTask({ loanConditionId, taskId }) {
    return this.#http.delete(`/api/loanConditions/${loanConditionId}/tasks/${taskId}`);
  }

  async editLoanCondition({ loanConditionId, ...body }) {
    return this.#http.put(`/api/loanConditions/${loanConditionId}`, body);
  }

  async getConditionHistory({ loanConditionId }) {
    return this.#http.get(`/api/loanConditions/${loanConditionId}/history`);
  }
}
